import styled from "styled-components"
import media from "styled-media-query"

export const Wrapper = styled.section`
  width: 100%;
  height: 400px;
  background-color: var(--backgroundHeroMore);

  ${media.lessThan("1000px")`
    height: 480px;
  `}

  ${media.lessThan("780px")`
    height: 510px;
  `}

  ${media.lessThan("500px")`
  height: 500px;
`}
${media.lessThan("420px")`
  height: 470px;
`}
`

export const Content = styled.div`
  max-width: 1190px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  padding-top: 15px;
  justify-content: center;

  ${media.lessThan("1049px")`
    flex-direction: column;
    align-items: center;
  `}
`

export const Text = styled.div`
  height: 100%;
  width: 550px;
  display: flex;
  flex-direction: column;

  ${media.lessThan("1059px")`
    text-align: center;
  `}

  ${media.lessThan("medium")`
    width: 100%;
  `}

  ${media.greaterThan("560px")`
    width: 80%;
  `}

  ${media.lessThan("560px")`
    margin: 10px;
  `}

`

export const Title = styled.h1`
  font-weight: normal;
  text-align: left;
  color: var(--whiteToBlack);

  span {
    color: #67f3aa;
  }

  ${media.greaterThan("560px")`
    font-size: 28px;
    line-height: 40px;
    line-height: 40px;
    margin: 40px 10px 10px;
    text-align: center;
  `}

  ${media.greaterThan("700px")`
    margin: 60px 10px 10px;
    font-size: 32px;
    text-align: center;
  `}

  ${media.greaterThan("1050px")`
    margin: 100px 40px 10px;
    text-align: left;
  `}

  ${media.greaterThan("1110px")`
    font-size: 34px;
    margin: 90px 60px 10px;
    line-height: 50px;
  `}

  ${media.lessThan("560px")`
    font-size: 26px;
    line-height: 40px;
    margin: 24px 10px 10px;
    text-align: center;
  `}

  ${media.lessThan("420px")`
    font-size: 25px;
    line-height: 38px;
    margin: 30px 8px 5px;
    -webkit-margin: 30px 8px 5px;
    -webkit-text-align: center;
    text-align: center;
  `}
`

export const Subtitle = styled(Title)`
  font-size: 24px;
  line-height: 29px;
  color: var(--greyToGreen);
  margin-top: 40px;

  ${media.greaterThan("500px")`
    font-size: 20px;
    padding: 0 40px;
    margin-top: 20px;
    line-height: 30px;

    text-align: left;
  `}

  ${media.greaterThan("560px")`
    font-size: 18px;
    padding: 0;
    margin-top: 20px;
    line-height: 30px;

    text-align: left;
  `}


  ${media.greaterThan("700px")`
    font-size: 22px;
    text-align: center;
    padding: 0 20px;
  `}

  ${media.greaterThan("1050px")`
    padding: 0;
    margin-top: 12px;
    text-align: left;
  `}

  ${media.greaterThan("1110px")`
    padding: 0 0;
  `}

  ${media.lessThan("500px")`
    font-size: 20px;
    padding: 0 10px;
    margin-top: 15px;
    line-height: 30px;
  
    text-align: center;
  `}

  ${media.lessThan("420px")`
    margin-top: 15px;
    -webkit-margin-top: 15px;
    -webkit-margin-bottom: 20px;
    margin-bottom: 20px;
    padding: 0 14px;

    text-align: left;
  `}
`

export const Image = styled.div`
  width: 565px;
  height: 272px;
  -webkit-transform: translateY(60px);

  img {
    object-fit: none;
  }

  div {
    border-radius: 0;
  }

  div:first-child {
    width: 100%;
    height: 100%;
  }

  ${media.lessThan("1170px")`
    width: 519px;
    height: 250px; 
  `}

  ${media.lessThan("1048px")`
    transform: translateY(10px);
  `}

  ${media.greaterThan("500px")`
  width: 405px;
  height: 210px;
`}

  ${media.greaterThan("560px")`
  width: 465px;
  height: 240px;
`}

${media.greaterThan("1050px")`
  width: 65%;
`}

  ${media.lessThan("500px")`
    width: 367px !important;
    height: 171px !important;
  `}

  ${media.lessThan("320px")`
    width: 100%;
    height: 50%;
  `}
`
